const secretKey = /(?:^|\.)(?:export_password(?:_confirmation)?|encryptedPassword)$/

// Match the server filter, including encoded Livewire snapshots and update pairs.
export function redactTenantExportSecrets(value) {
  if (Array.isArray(value)) {
    if (value.some(item => typeof item === 'string' && secretKey.test(item))) {
      return value.map(() => '[Filtered]')
    }
    return value.map(redactTenantExportSecrets)
  }
  if (value && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype) {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [
      key, secretKey.test(key) ? '[Filtered]' : redactTenantExportSecrets(item)
    ]))
  }
  if (typeof value === 'string' && ['{', '['].includes(value.trimStart()[0])) {
    try {
      const decoded = JSON.parse(value)
      const filtered = redactTenantExportSecrets(decoded)
      return JSON.stringify(decoded) === JSON.stringify(filtered) ? value : JSON.stringify(filtered)
    } catch {
      return value
    }
  }
  return value
}
